<template>
  <div class="slider" v-if="loading">
    <div class="loading">
      <img src="@/assets/vivo-consulta/imagens/spinner.svg" alt="Carregando...." />
    </div>
  </div>
  <div v-else>
    <div class="slider" @mouseover="clearTime()" @mouseout="autoSlide()">
      <template v-if="!!aparelhoComp">
        <div class="navegacao">
          <button class="nav-seta anterior" @click="setAnterior()">
            <img src="@/assets/vivo-consulta/icones/icone-seta-maior.png" />
          </button>
          <button class="nav-seta proximo" @click="setProximo()">
            <img src="@/assets/vivo-consulta/icones/icone-seta-maior.png" />
          </button>
          <ul>
            <li v-for="(nav, index) in aparelhos" :key="index">
              <button :class="sliderAtivo === index ? 'ativo' : ''" @click="setAtivo(index)"></button>
            </li>
          </ul>
        </div>

        <div class="div-aparelho" :key="aparelhoComp.cel.id" v-if="aparelhoComp.cel.id">
          <button-slider
            name="vivo.consulta.page"
            :params="{ page: 'smartphone', id: aparelhoComp.cel.id }"
            :key="aparelhoComp.cel.id"
            :model="aparelhoComp.cel.modelo"
          >VER APARELHO</button-slider>
        </div>

        <transition-group>
          <div class="conteudo" :key="transition">
            <div class="foto">
              <slider-imagem :imagem="aparelhoComp.cel.imagem" />
            </div>
            <div class="informacoes">
              <h1>
                {{ aparelhoComp.cel.marca.nome }}
                <br />
                <strong>{{ aparelhoComp.cel.modelo }}</strong>
              </h1>
              <ul>
                <li v-for="(plano, index) in aparelhoComp.cel.planos" :key="index">
                  <h4
                    :class="plano.plano.nome === 'VIVO FAMÍLIA 30GB' ? 'destaque' : ''"
                  >{{ plano.plano.nome }}</h4>
                  <img src="@/assets/vivo-consulta/imagens/separador.svg" />
                  <p :class="plano.plano.nome === 'VIVO FAMÍLIA 30GB' ? 'destaque' : ''">
                    R$
                    <strong>{{ plano.valor | convertMoeda }}</strong>
                  </p>
                  <!-- <small v-if="plano.desctipo === 'desconto'" class="positivo">
                <strong>-R${{ plano.desc }}</strong> ({{ plano.descpercent }}%)
              </small>
              <small v-else-if="plano.desctipo === 'aumento'" class="negativo">
                <strong>+R${{ plano.desc }}</strong> ({{ plano.descpercent }}%)
                  </small>-->
                </li>
              </ul>
            </div>
          </div>
        </transition-group>
      </template>

      <div class="fundo">
        <img src="@/assets/vivo-consulta/imagens/slider-background.jpg" />
      </div>
    </div>
  </div>
</template>

<script>
import ButtonSlider from './ButtonSlider';
import SliderImagem from './SliderImagem';
export default {
  name: 'Slider',
  components: {
    ButtonSlider,
    SliderImagem,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      aparelhos: {},
      numeroDeSliders: 0,
      sliderAtivo: 0,
      transition: 0,
      tempo: undefined,
    };
  },

  computed: {
    aparelhoComp() {
      return this.aparelhos[this.sliderAtivo];
    },
  },

  methods: {
    setSliders() {
      this.numeroDeSliders = this.aparelhos.length;
    },
    setAtivo(indice) {
      this.sliderAtivo = indice;
    },
    setProximo() {
      const tamanho = this.aparelhos.length - 1;
      this.sliderAtivo === tamanho
        ? (this.sliderAtivo = 0)
        : this.sliderAtivo++;
      this.transition++;
    },
    setAnterior() {
      const tamanho = this.aparelhos.length - 1;
      this.sliderAtivo === 0
        ? (this.sliderAtivo = tamanho)
        : this.sliderAtivo--;
      this.transition++;
    },
    autoSlide() {
      this.tempo = setTimeout(() => {
        this.setProximo(), this.autoSlide(), this.transition++;
      }, 5000);
    },
    clearTime() {
      window.clearTimeout(this.tempo);
    },
  },

  mounted() {
    this.aparelhos = this.data.data;
    this.setSliders();
    this.autoSlide();
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.slider {
  @extend %area-de-utilizacao;
  margin: 0 auto;
  left: 4px;
  margin-bottom: 80px;
  user-select: none;
  width: 976px;
  height: 323px;
  border-radius: 7px;
  border: 2px solid rgba(white, 0.1);
  position: relative;
  z-index: 10;
  box-shadow: 0px 20px 60px rgba(0, 0, 0, 0.5);

  @media (max-width: 976px) {
    width: 100% !important;
    height: auto;
  }

  & .loading {
    background: #fff;
    opacity: 0.7;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    border-radius: 3px;
    & img {
      height: 45px;
      width: 45px;
    }
  }

  & .div-aparelho {
    position: absolute;
    z-index: 3;
    bottom: 15px;
    right: 25px;
  }

  & .navegacao {
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    & button {
      display: flex;
      align-items: center;
      justify-content: center;
      background: transparent;
      height: 60px;
      width: 60px;
      border: 0px;
      margin: 0px;
      padding: 0px;
      outline: none;

      &:hover img {
        transform: scale(1.2);
      }

      &:active img {
        transform: scale(1.35);
      }
    }

    & .nav-seta {
      position: absolute;
      top: calc(50% - 30px);
      margin: 0px;
      padding: 0px;

      & img {
        height: 26px;
        widows: auto;
        transition: all 0.2s ease-in-out;
      }
    }

    & .anterior {
      left: 0;
    }

    & .proximo {
      right: 0;
      transform: rotate(180deg);
    }

    & ul {
      display: flex;
      flex-direction: row;
      align-items: center;
      position: absolute;
      z-index: 20;
      bottom: 0;
      margin-bottom: -30px;
      left: 50%;
      transform: translate(-50%, 0);

      & li {
        & button {
          width: 6px;
          height: 6px;
          border-radius: 3px;
          background: white;
          margin: 0 5px;
          transition: all 0.2s ease-in-out;
        }

        & .ativo {
          width: 10px;
          height: 10px;
          border-radius: 5px;
          background: $cor_roxo;
          margin: 0 3px;
          transition: all 0.2s ease-in-out;
        }
      }
    }
  }

  & .conteudo {
    z-index: 1;
    position: absolute;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;

    & .foto {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 0.47;
    }

    & .informacoes {
      flex: 0.53;

      & h1 {
        font-family: 'OpenSans';
        font-size:2.2vw;
        color: white;
        font-weight: 300;
        text-transform: uppercase;
        line-height: 1em;
        padding-left: 40px;
        padding-right: 40px;
        margin: 10px 0;

        & strong {
          font-family: 'VivoType';
        }
      }

      & ul {
        display: flex;
        flex-direction: column;
        padding: 0px;
        padding-left: 40px;

        & li {
          display: flex;
          flex-direction: row;
          align-items: center;
          color: white;
          margin: 2px 0;

          & h4 {
            font-size: 1.5vw;
            font-family: 'VivoType';
            text-transform: uppercase;
            line-height: 2em;
            margin: 0px;
            // max-width: 110px;
            font-weight: 600;
          }

          & .destaque {
            color: $cor_amarelo !important;
          }

          & img {
            opacity: 0.3;
            margin: 0 20px;
          }

          & p {
            font-size: 1.1vw;
            margin: 0px;
            margin-top: -2px;
            font-weight: 100;

            & strong {
              font-weight: 700;
            }
          }

          & small {
            margin-left: 20px;
            padding: 5px 10px;
            font-size: 1.13vw;
            font-weight: 100;
            border-radius: 2px;

            & strong {
              font-weight: 600;
            }

            & ::before {
              content: '';
              width: 10px;
              height: 10px;
              position: absolute;
              top: 10px;
              left: 0;
              margin-left: -2px;
              transform: rotate(45deg);
              z-index: -1;
            }
          }

          & .positivo {
            position: relative;
            background: #2ecd50;

            & ::before {
              background: #2ecd50;
            }
          }

          & .negativo {
            position: relative;
            background: #ff1f00;

            & ::before {
              background: #ff1f00;
            }
          }
        }
      }
    }
  }

  & .fundo {
    border-radius: 5px;

    & img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 5px;
    }
  }
}

// ANIMATION - SLIDE TOP/DOWN
// .v-enter { opacity: 0; margin-top: -50px }
// .v-enter-to { opacity: 1; margin-top: 0px }
// .v-enter-active { transition: all .5s ease-out}
// .v-leave-active { transition: all .5s ease-in}
// .v-leave-to { opacity: 0; margin-top: 50px }
// .v-leave { opacity: 1; margin-top: 0px }

// ANIMATION - FLIP VERTICAL
.v-enter {
  opacity: 0;
  transform: rotateX(180deg);
}
.v-enter-to {
  opacity: 1;
}
.v-enter-active {
  transition: all 0.75s ease-in-out;
  transform-style: preserve-3d;
}
.v-leave-active {
  transition: all 0.75s ease-in-out;
  transform-style: preserve-3d;
}
.v-leave-to {
  opacity: 0;
  transform: rotateX(-180deg);
}
.v-leave {
  opacity: 1;
}
</style>
